import { PageTitle } from '@/components/PageTitle';
import { IconTile } from '@/components/IconTile';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  size?: 'page' | 'section';
}

/** Page title with optional leading icon tile (toolkit detail, etc.). */
export function PageHeader({ title, subtitle, icon, size = 'page' }: PageHeaderProps) {
  if (!icon) {
    return <PageTitle title={title} subtitle={subtitle} size={size} />;
  }

  return (
    <header className="flex items-center gap-3">
      <IconTile icon={icon} size="md" />
      <PageTitle title={title} subtitle={subtitle} size={size} />
    </header>
  );
}
